import axios from 'axios';

import { addOrEditItem, API_ROOT, deleteItem, getItems, logApiError } from './api';
import { clientIdFromSearch, withOwnerScope } from '@/services/onboarding_resolve';

// Scope an account read/write to the route's ?client_id owner when one is present.
// Same helper the onboarding store uses (ENG-2726); applied only to the actions a
// viewer legitimately operates on *for a client*, never to the viewer's own profile.
const ownerScoped =
    action =>
    (context, payload = {}) => {
        const search = typeof window !== 'undefined' ? window.location.search : '';
        return action(context, withOwnerScope(payload, clientIdFromSearch(search)));
    };

export default {
    namespaced: true,
    actions: {
        createUserDocumentItem: addOrEditItem('documents/'),
        deleteUserDocumentItem: deleteItem('documents/'),
        deleteUserFileItem: deleteItem('file/'),
        async getUserDeals({ dispatch, rootGetters }, payload = {}) {
            const userId = payload.user_id || rootGetters.user.uuid;
            try {
                const { data } = await axios.get(`${API_ROOT}/${userId}/deals/`, rootGetters.axiosConfig);
                return data;
            } catch (e) {
                logApiError(e, dispatch);
                throw e;
            }
        },
        getUserDocuments: getItems('documents/'),
        addSolarActivity: addOrEditItem('material_participation_activities/'),
        getSolarActivities: getItems('material_participation_activities/'),
        // The server sets the hours, date and category from the playlist item, and returns the
        // row already logged for the video (200, not 201) when it is opened again.
        logVideoActivity({ dispatch }, { playlistItemId, description }) {
            return dispatch('addSolarActivity', { action: 'log_video', playlist_item: playlistItemId, description });
        },
        getSolarActivitiesPlaylists: getItems('material_participation_playlists/'),
        addSolarActivityDocument: addOrEditItem('material_participation_documents/'),
        deleteSolarActivityDocument: deleteItem('material_participation_documents/'),
        createSolarAccessRequest: addOrEditItem('solar_access_requests/'),
        getSolarAccessRequests: getItems('solar_access_requests/'),
        getPendingSolarAccessRequest: getItems('solar_access_requests/pending/'),
        // Points of contact belong to the trust's owner. The project view's Contacts
        // tab is reachable by advisors/ops since ENG-2742, and unscoped these would
        // read — and overwrite — the *viewer's* own notification contacts while the
        // page claims to be showing the client's project.
        getPocPreferences: ownerScoped(getItems('poc-preferences/')),
        savePocPreferences: ownerScoped(addOrEditItem('poc-preferences/')),
        // One year of the log as a `csv` or `pdf` Blob, or null when the download failed.
        async exportMaterialParticipationLog({ dispatch, rootGetters }, { format, year }) {
            const userId = rootGetters.user.uuid;
            try {
                const { data } = await axios.get(
                    `${API_ROOT}/${userId}/material_participation_activities/export_${format}/`,
                    {
                        ...rootGetters.axiosConfig,
                        params: { year },
                        responseType: 'blob',
                    },
                );
                return data;
            } catch (e) {
                logApiError(e, dispatch);
                return null;
            }
        },
    },
};
